import { ControllerProtocol } from '../typings/ControllerProtocol'
import { JSBridgeReturnType } from '../typings/JSBridgeProtocol'
import { StaticData } from '../typings/StaticData'

export class BaseController implements ControllerProtocol {

  checkReady(timeout?: number): Promise<JSBridgeReturnType<boolean>> {
    return Promise.resolve([false, null])
  }

  getStaticData(timeout?: number): Promise<JSBridgeReturnType<StaticData | false>> {
    return Promise.resolve([false, null])
  }

  callAndBackfeed<T>(scheme: string): Promise<JSBridgeReturnType<false | T>> {
    return Promise.resolve([false, null])
  }

  callAndListen<T>(scheme: string, callback: (data: T) => void): Promise<JSBridgeReturnType<false | (() => void)>> {
    return Promise.resolve([false, null])
  }

}
